import * as i0 from '@angular/core';
import * as i1 from './modal.module';
import * as i2 from './modal-backdrop';
import * as i3 from './modal-window';
export const NgbModalModuleNgFactory:i0.NgModuleFactory<i1.NgbModalModule> = (null as any);
var _decl0_0:i2.NgbModalBackdrop = (<any>(null as any));
var _decl0_1:i3.NgbModalWindow = (<any>(null as any));
var _decl0_2:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_3:i0.ElementRef<any> = (<any>(null as any));
function _View_NgbModalBackdrop_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_NgbModalBackdrop_1_0():void {
  var _any:any = (null as any);
}
function _View_NgbModalWindow_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_NgbModalWindow_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (('modal-dialog' + (_decl0_1.size? (' modal-' + _decl0_1.size): '')) + (_decl0_1.centered? ' modal-dialog-centered': ''));
  currVal_0;
}
